import { menuParameterDisp, sentBuryPointInfo } from "./buryPoint";

// 专门记录下载埋点
export const downloadTracking = (
  path,
  { data, params, eventCode, eventName, ...eventContext }
) => {
  const parameter = menuParameterDisp(path);
  if (parameter) {
    sentBuryPointInfo({
      ...parameter,
      eventName: eventName || "点击下载",
      eventCode: eventCode || "download",
      eventContext: {
        ...eventContext,
        data: filterParams(data),
        params: filterParams(params),
      },
    });
  }
};
const filterParams = (params, keys = ["token"]) => {
  if (!params) return params;
  try {
    const data = JSON.parse(params);
    const res = {};
    Object.keys(data)
      .filter((val) => !keys.includes(val))
      .map((k) => {
        res[k] = data[k];
      });
    return JSON.stringify(res);
  } catch (e) {
    return params;
  }
};

export function downloadFile(data, filename) {
  if (!data) {
    return;
  }
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", filename || "excel.xlsx");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function substr(str, n) {
  if (str.replace(/[\u4e00-\u9fa5]/g, "**").length <= n) {
    return str;
  } else {
    var len = 0;
    var tmpStr = "";
    for (var i = 0; i < str.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(str[i])) {
        len += 2;
      } else {
        len += 1;
      }
      if (len > n) {
        break;
      } else {
        tmpStr += str[i];
      }
    }
    return tmpStr + " ...";
  }
}
// 字符串长度
export function strlen(str) {
  if (str == null) return 0;
  if (typeof str !== "string") {
    str += "";
  }
  return str.replace(/[^\x00-\xff]/g, "01").length;
}
/**
 * 深度复制对象数组
 * @param {Object,Array} source 对象数组
 */
export function copyObject(source) {
  if (typeof source !== "object") return source;
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] =
      typeof source[item] === "object" && source[item] !== null
        ? copyObject(source[item])
        : source[item];
  }
  return sourceCopy;
}
/**
 * 深度合并对象数组
 * @param {Object,Array} source 对象数组
 */
export function mergeObject(firstObj, secondObj) {
  var sourceData = copyObject(firstObj);
  if (typeof firstObj !== "object" || typeof secondObj !== "object") {
    sourceData = copyObject(secondObj !== undefined ? secondObj : firstObj);
  } else {
    for (var key in secondObj) {
      sourceData[key] =
        firstObj[key] && firstObj[key].toString() === "[object Object]"
          ? mergeObject(firstObj[key], secondObj[key])
          : secondObj[key];
    }
  }
  return sourceData;
}

/**
 * 参数对象拼装为uri
 * @param {Object} params URL参数
 */
export function queryEncoded(params) {
  var queryStr = "";
  for (const key in params) {
    const value = encodeURIComponent(params[key]);
    if (value === "" || value === undefined) continue;
    queryStr += "&" + key + "=" + value;
  }
  return queryStr.substr(1);
}

export function parseUrl(url) {
  var params = {};
  var urls = url.split("?");
  var paths = [];
  var path = (url = "");
  if (urls.length === 1) {
    urls[1] = url;
  }
  paths = urls[0].split("#");
  if (paths.length === 1) {
    path = paths[0];
  } else if (paths.length === 2) {
    url = paths[0];
    path = paths[1];
  }
  var arr = urls[1].split("&");
  for (var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split("=");
    params[a[0]] = a[1];
  }
  return {
    url: url,
    path: path,
    query: params,
  };
}
